<script>
export default {
  data() {
    return {
      bundleTypes: [
        'SINGLE',
        'SET',
        'BUNDLE',
      ],
      asin_title: '',
      fnsku_title: '',
      isSwitched: false,
      validators: {
        asin: {
          valid: true,
          regexp: /^[a-zA-Z0-9]{10}$/,
          validator: 'asin',
        },
        quantity: {
          valid: true,
          max: 50001,
          validator: 'quantity',
        },
        in_set: {
          valid: true,
          max: 100,
          validator: 'in_set',
        },
        fnsku_title: {
          valid: true,
          validator: 'fnsku_title',
        },
      },
    };
  },
  props: [
    'product',
    'index',
  ],
  created() {
    if (this.product.product_id && !this.product.asin) {
      this.isSwitched = true;
      this.product.is_non_amazon = true;
      this.fnsku_title = this.product.title;
    } else {
      this.asin_title = this.product.title;
    }
  },
  methods: {
    isValidAsin() {
      const preparedValidators = Object.keys(this.validators).filter((item) => item !== 'fnsku_title');

      const isValid = preparedValidators
        .filter(
          (key) => this.validators[key].valid === true,
        ).length === preparedValidators.length;

      this.product.title = this.isSwitched ? this.fnsku_title : this.asin_title;
      this.$emit('set_validator', this.product, isValid);
    },

    isValidFnsku() {
      const preparedValidators = Object.keys(this.validators).filter((item) => item !== 'asin');

      const isValid = preparedValidators
        .filter(
          (key) => this.validators[key].valid === true,
        ).length === preparedValidators.length;
      this.$emit('set_validator', this.product, isValid);
    },

    validate(type, value) {
      if (type === 'asin') {
        this.validators[type].valid = this.validators[type].regexp.test(value);
        this.isValidAsin();
        return;
      }

      if (type === 'fnsku_title') {
        this.validators[type].valid = value.length > 0;
        this.isValidFnsku();
        return;
      }

      this.validators[type].valid = value > 0 && value < this.validators[type].max;
    },

    getASIN(product, value) {
      if (typeof value === 'undefined' || value.length < 10) return;

      const { asin } = product;
      product.loadProductInfo = true;

      this.$store.dispatch('getASINInfo', asin)
        .then((data) => {
          product.image = data.image;
          product.product_id = data.id;
          this.asin_title = data.title;
          product.loadProductInfo = false;
        })
        .catch((ex) => {
          product.loadProductInfo = false;
          console.log('ERROR:', ex);
        });
    },

    setInSet(product) {
      switch(product.bundle_type) {
        case 'SINGLE':
          product.in_set = 1;
          break;

        case 'SET':
          product.in_set = 2;
          break;

        case 'BUNDLE':
          product.in_set = 3;
          break;
      }
    },

    remove(index) {
      this.$emit('remove', index);
    },

    toggleSwitch() {
      this.isSwitched = !this.isSwitched;
      this.product.is_non_amazon = !this.product.is_non_amazon;
      if (!this.isSwitched) {
        this.isValidAsin();
      } else {
        this.isValidFnsku();
      }
    },
  },
};
</script>
<template src="./product_component.pug" lang="pug"></template>
<style src="./product_component.styl" lang="stylus"></style>
